const categoryByName = {
  News: 1,
  Events: 2,
  ClubNews: 3,
  Gastronomy: 4,
  Leisure: 5,
  JobMarket: 6,
  ServiceProviders: 7,
  Shopping: 8,
  BuySell: 9,
  TownHall: 10,
  Newsletter: 11,
  TourismLeisure: 12,

  BreakingNews: 13,
  Politics: 14,
  Economy: 15,
  Sports: 16,
  LocalNews: 17,
  RoadworkTraffic: 18,
  OfficialAnnouncements: 19,
  TimelessNews: 20,

  Hotels: 21,
  Restaurants: 22,
  Menus: 23,
  CurrentDailyOffers: 24,

  SportsActivities: 25,
  Wellness: 26,
  OutdoorActivities: 27,
  SightsAttractions: 28,
  DayTrips: 29,

  Handicraft: 30,
  Health: 31,
  RealEstate: 32,
  Finances: 33,

  Trade: 34,
  Offers: 35,

  CyclingRoutes: 36,
  HikingTrails: 37,
};

const categoryById = {
  1: "News",
  2: "Events",
  3: "ClubNews",
  4: "Gastronomy",
  5: "Leisure",
  6: "JobMarket",
  7: "ServiceProviders",
  8: "Shopping",
  9: "BuySell",
  10: "TownHall",
  11: "Newsletter",
  12: "TourismLeisure",

  13: "BreakingNews",
  14: "Politics",
  15: "Economy",
  16: "Sports",
  17: "LocalNews",
  18: "RoadworkTraffic",
  19: "OfficialAnnouncements",
  20: "TimelessNews",

  21: "Hotels",
  22: "Restaurants",
  23: "Menus",
  24: "CurrentDailyOffers",

  25: "SportsActivities",
  26: "Wellness",
  27: "OutdoorActivities",
  28: "SightsAttractions",
  29: "DayTrips",

  30: "Handicraft",
  31: "Health",
  32: "RealEstate",
  33: "Finances",

  34: "Trade",
  35: "Offers",

  36: "CyclingRoutes",
  37: "HikingTrails",
};

module.exports = { categoryByName, categoryById };
